import type { ComponentProps } from 'react';

type SVGProps = ComponentProps<'svg'>;

export const Work = ({
  width = 24,
  height = 24,
  fill = '#8B9195',
  ...rest
}: SVGProps) => (
  <svg
    aria-hidden="true"
    fill="none"
    height={height}
    viewBox="0 0 24 24"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M4 21C3.45 21 2.97917 20.8042 2.5875 20.4125C2.19583 20.0208 2 19.55 2 19V8C2 7.45 2.19583 6.97917 2.5875 6.5875C2.97917 6.19583 3.45 6 4 6H8V4C8 3.45 8.19583 2.97917 8.5875 2.5875C8.97917 2.19583 9.45 2 10 2H14C14.55 2 15.0208 2.19583 15.4125 2.5875C15.8042 2.97917 16 3.45 16 4V6H20C20.55 6 21.0208 6.19583 21.4125 6.5875C21.8042 6.97917 22 7.45 22 8V19C22 19.55 21.8042 20.0208 21.4125 20.4125C21.0208 20.8042 20.55 21 20 21H4ZM4 19H20V8H4V19ZM10 6H14V4H10V6Z"
      fill={fill}
    />
  </svg>
);

export const UniversalCurrencyAlt = ({
  width = 24,
  height = 24,
  fill = '#8B9195',
  ...rest
}: SVGProps) => (
  <svg
    aria-hidden="true"
    fill="none"
    height={height}
    viewBox="0 0 24 24"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M4 19C3.45 19 2.97917 18.8042 2.5875 18.4125C2.19583 18.0208 2 17.55 2 17V7C2 6.45 2.19583 5.97917 2.5875 5.5875C2.97917 5.19583 3.45 5 4 5H20C20.55 5 21.0208 5.19583 21.4125 5.5875C21.8042 5.97917 22 6.45 22 7V17C22 17.55 21.8042 18.0208 21.4125 18.4125C21.0208 18.8042 20.55 19 20 19H4ZM4 17H20V7H4V17ZM17.5 14.5H15.75C15.5333 14.5 15.3542 14.5708 15.2125 14.7125C15.0708 14.8542 15 15.0333 15 15.25C15 15.4667 15.0708 15.6458 15.2125 15.7875C15.3542 15.9292 15.5333 16 15.75 16H18C18.2833 16 18.5208 15.9042 18.7125 15.7125C18.9042 15.5208 19 15.2833 19 15V12.75C19 12.5333 18.9292 12.3542 18.7875 12.2125C18.6458 12.0708 18.4667 12 18.25 12C18.0333 12 17.8542 12.0708 17.7125 12.2125C17.5708 12.3542 17.5 12.5333 17.5 12.75V14.5ZM12 15C12.8333 15 13.5417 14.7083 14.125 14.125C14.7083 13.5417 15 12.8333 15 12C15 11.1667 14.7083 10.4583 14.125 9.875C13.5417 9.29167 12.8333 9 12 9C11.1667 9 10.4583 9.29167 9.875 9.875C9.29167 10.4583 9 11.1667 9 12C9 12.8333 9.29167 13.5417 9.875 14.125C10.4583 14.7083 11.1667 15 12 15ZM6.5 9.5H8.25C8.46667 9.5 8.64583 9.42917 8.7875 9.2875C8.92917 9.14583 9 8.96667 9 8.75C9 8.53333 8.92917 8.35417 8.7875 8.2125C8.64583 8.07083 8.46667 8 8.25 8H6C5.71667 8 5.47917 8.09583 5.2875 8.2875C5.09583 8.47917 5 8.71667 5 9V11.25C5 11.4667 5.07083 11.6458 5.2125 11.7875C5.35417 11.9292 5.53333 12 5.75 12C5.96667 12 6.14583 11.9292 6.2875 11.7875C6.42917 11.6458 6.5 11.4667 6.5 11.25V9.5Z"
      fill={fill}
    />
  </svg>
);

export const Code = ({
  width = 24,
  height = 24,
  fill = '#8B9195',
  ...rest
}: SVGProps) => (
  <svg
    aria-hidden="true"
    fill="none"
    height={height}
    viewBox="0 0 24 24"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M4.82578 12.0249L8.70078 15.8999C8.88411 16.0832 8.97578 16.3166 8.97578 16.5999C8.97578 16.8832 8.88411 17.1166 8.70078 17.2999C8.51745 17.4832 8.28411 17.5749 8.00078 17.5749C7.71745 17.5749 7.48411 17.4832 7.30078 17.2999L2.70078 12.6999C2.60078 12.5999 2.52995 12.4916 2.48828 12.3749C2.44661 12.2582 2.42578 12.1332 2.42578 11.9999C2.42578 11.8666 2.44661 11.7416 2.48828 11.6249C2.52995 11.5082 2.60078 11.3999 2.70078 11.2999L7.30078 6.6999C7.50078 6.4999 7.73828 6.3999 8.01328 6.3999C8.28828 6.3999 8.52578 6.4999 8.72578 6.6999C8.92578 6.8999 9.02578 7.1374 9.02578 7.4124C9.02578 7.6874 8.92578 7.9249 8.72578 8.1249L4.82578 12.0249ZM19.1758 11.9749L15.3008 8.0999C15.1174 7.91657 15.0258 7.68324 15.0258 7.3999C15.0258 7.11657 15.1174 6.88324 15.3008 6.6999C15.4841 6.51657 15.7174 6.4249 16.0008 6.4249C16.2841 6.4249 16.5174 6.51657 16.7008 6.6999L21.3008 11.2999C21.4008 11.3999 21.4716 11.5082 21.5133 11.6249C21.5549 11.7416 21.5758 11.8666 21.5758 11.9999C21.5758 12.1332 21.5549 12.2582 21.5133 12.3749C21.4716 12.4916 21.4008 12.5999 21.3008 12.6999L16.7008 17.2999C16.5008 17.4999 16.2674 17.5957 16.0008 17.5874C15.7341 17.5791 15.5008 17.4749 15.3008 17.2749C15.1008 17.0749 15.0008 16.8374 15.0008 16.5624C15.0008 16.2874 15.1008 16.0499 15.3008 15.8499L19.1758 11.9749Z"
      fill={fill}
    />
  </svg>
);

export const Stat0 = ({
  width = 24,
  height = 24,
  fill = '#8B9195',
  ...rest
}: SVGProps) => (
  <svg
    aria-hidden="true"
    fill="none"
    height={height}
    viewBox="0 0 24 24"
    width={width}
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      d="M10.5742 17.5752L6.42422 13.4252C6.22422 13.2252 6.07422 13.0002 5.97422 12.7502C5.87422 12.5002 5.82422 12.2502 5.82422 12.0002C5.82422 11.7502 5.87422 11.5002 5.97422 11.2502C6.07422 11.0002 6.22422 10.7752 6.42422 10.5752L10.5742 6.4252C10.7742 6.2252 10.9992 6.0752 11.2492 5.9752C11.4992 5.8752 11.7492 5.8252 11.9992 5.8252C12.2492 5.8252 12.4992 5.8752 12.7492 5.9752C12.9992 6.0752 13.2242 6.2252 13.4242 6.4252L17.5742 10.5752C17.7742 10.7752 17.9242 11.0002 18.0242 11.2502C18.1242 11.5002 18.1742 11.7502 18.1742 12.0002C18.1742 12.2502 18.1242 12.5002 18.0242 12.7502C17.9242 13.0002 17.7742 13.2252 17.5742 13.4252L13.4242 17.5752C13.2242 17.7752 12.9992 17.9252 12.7492 18.0252C12.4992 18.1252 12.2492 18.1752 11.9992 18.1752C11.7492 18.1752 11.4992 18.1252 11.2492 18.0252C10.9992 17.9252 10.7742 17.7752 10.5742 17.5752ZM11.9992 16.1502L16.1492 12.0002L11.9992 7.8502L7.84922 12.0002L11.9992 16.1502Z"
      fill={fill}
    />
  </svg>
);
